var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluationTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 6.66667H9.33464C8.62739 6.66667 7.94911 6.94762 7.44902 7.44772C6.94892 7.94781 6.66797 8.62609 6.66797 9.33333V25.3333C6.66797 26.0406 6.94892 26.7189 7.44902 27.219C7.94911 27.719 8.62739 28 9.33464 28H22.668C23.3752 28 24.0535 27.719 24.5536 27.219C25.0537 26.7189 25.3346 26.0406 25.3346 25.3333V9.33333C25.3346 8.62609 25.0537 7.94781 24.5536 7.44772C24.0535 6.94762 23.3752 6.66667 22.668 6.66667H20.0013M12.0013 6.66667C12.0013 5.95942 12.2823 5.28115 12.7824 4.78105C13.2824 4.28095 13.9607 4 14.668 4H17.3346C18.0419 4 18.7202 4.28095 19.2203 4.78105C19.7204 5.28115 20.0013 5.95942 20.0013 6.66667M12.0013 6.66667C12.0013 7.37391 12.2823 8.05219 12.7824 8.55229C13.2824 9.05238 13.9607 9.33333 14.668 9.33333H17.3346C18.0419 9.33333 18.7202 9.05238 19.2203 8.55229C19.7204 8.05219 20.0013 7.37391 20.0013 6.66667M12.0013 18.6667H12.0146M12.0013 22.6667H12.0146M16.0013 21.3333L17.3346 22.6667L21.3346 18.6667",
    stroke: "#0C3450",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationTestIcon);
export default __webpack_public_path__ + "static/media/evaluationTestIcon.98f9c5ab7fc6ed800265c9396adcd89e.svg";
export { ForwardRef as ReactComponent };